document.querySelectorAll('[data-wtm-section]').forEach((sectionEl) => {
  if (sectionEl.dataset.wtmInitialized === '1') return;

  const start = () => {
    if (sectionEl.dataset.wtmInitialized === '1') return;
    sectionEl.dataset.wtmInitialized = '1';
    initShopTheLook(sectionEl);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(sectionEl);
        start();
      });
    }, { rootMargin: '300px 0px' });

    observer.observe(sectionEl);
  } else {
    start();
  }
});

function initShopTheLook(sectionEl) {
  var autoplayLightbox = true;

  function ensureSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
      return;
    }

    var existingScript = document.querySelector('script[data-wtm-swiper]');
    if (existingScript) {
      var waitCount = 0;
      var waitTimer = setInterval(function () {
        if (typeof Swiper !== "undefined") {
          clearInterval(waitTimer);
          callback();
        }
        waitCount++;
        if (waitCount > 100) clearInterval(waitTimer);
      }, 100);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.async = true;
    script.setAttribute('data-wtm-swiper', '1');

    script.onload = function () {
      callback();
    };

    document.body.appendChild(script);
  }

  function initWhenSwiperReady() {
    var mainTrack = sectionEl.querySelector("[data-wtm-main-track]");
    var cards = mainTrack ? Array.prototype.slice.call(mainTrack.querySelectorAll("[data-wtm-card]")) : [];
    var prevBtn = sectionEl.querySelector("[data-main-prev]");
    var nextBtn = sectionEl.querySelector("[data-main-next]");

    var lightbox = sectionEl.querySelector("[data-lightbox]");
    var closeButtons = lightbox ? Array.prototype.slice.call(lightbox.querySelectorAll("[data-close-lightbox]")) : [];
    var backdrop = lightbox ? lightbox.querySelector(".wtm-lightbox-backdrop") : null;
    var swiperEl = sectionEl.querySelector(".wtm-lightbox-swiper");

    if (!mainTrack || !lightbox || !swiperEl || !cards.length) return;

    var INITIAL_LOAD = 5;
    var PREFETCH_AHEAD = 5;
    var lastMainIndex = 0;
    var originalCardCount = cards.length;

    function getMainTrackAllCards() {
      return Array.prototype.slice.call(mainTrack.querySelectorAll("[data-wtm-card]"));
    }

    function getOriginalMainCards() {
      return Array.prototype.slice.call(mainTrack.querySelectorAll("[data-wtm-card]:not([data-clone='1'])"));
    }

    function getOriginalSlideIndexFromCard(cardEl) {
      if (!cardEl) return 0;

      var direct = cardEl.getAttribute("data-index");
      if (direct !== null) return parseInt(direct, 10) || 0;

      var all = getMainTrackAllCards();
      var idx = all.indexOf(cardEl);
      if (idx < 0) return 0;

      var count = originalCardCount || 1;
      return idx % count;
    }

    function getCardCenterTarget(card) {
      if (!card) return 0;
      return card.offsetLeft - (mainTrack.clientWidth / 2) + (card.clientWidth / 2);
    }

    function centerCardByIndex(index, behavior) {
      var card = cards[index];
      if (!card) return;
      mainTrack.scrollTo({
        left: Math.max(0, getCardCenterTarget(card)),
        behavior: behavior || "smooth"
      });
    }

    function normalizeMainTrackLoop() {
      if (!mainTrack._wtmLoopReady) return;

      var segmentWidth = mainTrack._wtmSegmentWidth || 0;
      if (!segmentWidth) return;

      if (mainTrack.scrollLeft < segmentWidth * 0.5) {
        mainTrack.scrollLeft += segmentWidth;
      } else if (mainTrack.scrollLeft > segmentWidth * 1.5) {
        mainTrack.scrollLeft -= segmentWidth;
      }
    }

    function buildInfiniteMainTrack() {
      if (mainTrack._wtmLoopReady) return;

      var originals = getOriginalMainCards();
      if (!originals.length) return;

      originalCardCount = originals.length;

      var fragLeft = document.createDocumentFragment();
      var fragRight = document.createDocumentFragment();

      originals.forEach(function (card) {
        var leftClone = card.cloneNode(true);
        leftClone.setAttribute("data-clone", "1");
        leftClone.removeAttribute("data-index");
        fragLeft.appendChild(leftClone);

        var rightClone = card.cloneNode(true);
        rightClone.setAttribute("data-clone", "1");
        rightClone.removeAttribute("data-index");
        fragRight.appendChild(rightClone);
      });

      mainTrack.insertBefore(fragLeft, mainTrack.firstChild);
      mainTrack.appendChild(fragRight);

      cards = getMainTrackAllCards();

      requestAnimationFrame(function () {
        var allCards = getMainTrackAllCards();
        var firstMiddle = allCards[originalCardCount];
        var lastMiddle = allCards[(originalCardCount * 2) - 1];

        if (!firstMiddle || !lastMiddle) return;

        var segmentWidth = (lastMiddle.offsetLeft + lastMiddle.offsetWidth) - firstMiddle.offsetLeft;
        mainTrack._wtmSegmentWidth = segmentWidth;
        mainTrack._wtmLoopReady = true;

        mainTrack.scrollLeft = firstMiddle.offsetLeft;

        updateMainTrack3DClasses();
        resumeMainTrackVideo();
      });
    }

    function getCenteredMainIndex() {
      if (!cards.length) return 0;

      normalizeMainTrackLoop();

      var trackCenter = mainTrack.scrollLeft + (mainTrack.clientWidth / 2);
      var bestIdx = 0;
      var bestDist = Infinity;

      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var cardCenter = c.offsetLeft + (c.clientWidth / 2);
        var d = Math.abs(cardCenter - trackCenter);

        if (d < bestDist) {
          bestDist = d;
          bestIdx = i;
        }
      }

      return bestIdx;
    }

    function updateMainTrack3DClasses() {
      if (!cards.length) return;

      normalizeMainTrackLoop();

      var activeIdx = getCenteredMainIndex();

      cards.forEach(function (card, i) {
        card.classList.remove("is-main-active", "is-main-prev", "is-main-next", "is-main-far");

        if (i === activeIdx) {
          card.classList.add("is-main-active");
        } else if (i === activeIdx - 1) {
          card.classList.add("is-main-prev");
        } else if (i === activeIdx + 1) {
          card.classList.add("is-main-next");
        } else {
          card.classList.add("is-main-far");
        }
      });
    }

    function isElementInViewportWithinTrack(element) {
      var rect = element.getBoundingClientRect();
      var trackRect = mainTrack.getBoundingClientRect();
      var overlapX = Math.min(rect.right, trackRect.right) - Math.max(rect.left, trackRect.left);
      var visibleRatio = overlapX / Math.max(1, rect.width);
      return visibleRatio > 0.55;
    }

    function pauseMainTrackVideos() {
      cards.forEach(function (card) {
        var v = card.querySelector("video");
        if (v) v.pause();
      });
    }

    function resumeMainTrackVideo() {
      var idx = getCenteredMainIndex();
      lastMainIndex = idx;

      loadVideosRangeInCards(cards, idx, idx + PREFETCH_AHEAD);
      updateMainTrack3DClasses();

      cards.forEach(function (card) {
        var v = card.querySelector("video");
        if (!v) return;

        if (isElementInViewportWithinTrack(card)) {
          v.muted = true;
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    function deferVideoSourcesInCards(list, keepCount) {
      list.forEach(function (card, idx) {
        var video = card.querySelector("video");
        if (!video) return;

        video.preload = "none";
        video.removeAttribute("autoplay");

        if (idx >= keepCount && video.getAttribute("src")) {
          video.setAttribute("data-src", video.getAttribute("src"));
          video.removeAttribute("src");
        }

        var sources = video.querySelectorAll("source");
        sources.forEach(function (s) {
          if (idx >= keepCount && s.getAttribute("src")) {
            s.setAttribute("data-src", s.getAttribute("src"));
            s.removeAttribute("src");
          }
        });

        if (idx >= keepCount) video.load();
      });
    }

    function loadVideosRangeInCards(list, start, end) {
      for (var i = start; i < end && i < list.length; i++) {
        var card = list[i];
        var video = card.querySelector("video");
        if (!video) continue;

        var didSet = false;
        var vds = video.getAttribute("data-src");

        if (vds && !video.getAttribute("src")) {
          video.setAttribute("src", vds);
          video.removeAttribute("data-src");
          didSet = true;
        }

        var sources = video.querySelectorAll("source");
        sources.forEach(function (s) {
          var ds = s.getAttribute("data-src");
          if (ds && !s.getAttribute("src")) {
            s.setAttribute("src", ds);
            s.removeAttribute("data-src");
            didSet = true;
          }
        });

        if (didSet) video.load();
      }
    }

    deferVideoSourcesInCards(cards, INITIAL_LOAD);
    loadVideosRangeInCards(cards, 0, INITIAL_LOAD);

    // Don't download lightbox videos until a slide is opened
    var lightboxSlides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
    deferVideoSourcesInCards(lightboxSlides, 0);

    buildInfiniteMainTrack();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        var idx = parseInt(card.getAttribute("data-index"), 10) || 0;

        if (entry.isIntersecting) {
          lastMainIndex = idx;
          loadVideosRangeInCards(cards, Math.max(0, idx), idx + PREFETCH_AHEAD);

          var v = card.querySelector("video");
          if (v) {
            v.muted = true;
            v.play().catch(function () {});
          }
        } else {
          var v2 = card.querySelector("video");
          if (v2) v2.pause();
        }

        updateMainTrack3DClasses();
      });
    }, { root: mainTrack, threshold: 0.6 });

    getOriginalMainCards().forEach(function (card) {
      io.observe(card);
    });

    var isPointerDown = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragStartScrollLeft = 0;
    var movedByDrag = false;
    var tapCard = null;
    var pointerScrolled = false;
    var isVerticalGesture = false;
    var downTime = 0;

    function onPointerDown(e) {
      if (e.target.closest("[data-main-prev], [data-main-next]")) return;

      isPointerDown = true;
      movedByDrag = false;
      pointerScrolled = false;
      isVerticalGesture = false;
      downTime = Date.now();

      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragStartScrollLeft = mainTrack.scrollLeft;
      tapCard = e.target.closest("[data-wtm-card]");

      mainTrack.classList.add("is-dragging");
    }

    function onPointerMove(e) {
      if (!isPointerDown) return;

      var dx = e.clientX - dragStartX;
      var dy = e.clientY - dragStartY;

      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
        isVerticalGesture = true;
        tapCard = null;
        return;
      }

      if (Math.abs(dx) > 8) {
        movedByDrag = true;
        pointerScrolled = true;
        tapCard = null;
      }

      if (!movedByDrag) return;

      mainTrack.scrollLeft = dragStartScrollLeft - dx;
      normalizeMainTrackLoop();
      updateMainTrack3DClasses();
    }

    function endMainDrag(e) {
      if (!isPointerDown) return;
      isPointerDown = false;

      mainTrack.classList.remove("is-dragging");

      var endX = typeof e.clientX === "number" ? e.clientX : dragStartX;
      var endY = typeof e.clientY === "number" ? e.clientY : dragStartY;

      var totalDx = Math.abs(endX - dragStartX);
      var totalDy = Math.abs(endY - dragStartY);
      var pressDuration = Date.now() - downTime;
      var didScroll = Math.abs(mainTrack.scrollLeft - dragStartScrollLeft) > 6;

      if (
        movedByDrag ||
        pointerScrolled ||
        isVerticalGesture ||
        didScroll ||
        totalDx > 8 ||
        totalDy > 8
      ) {
        var centerIdx = getCenteredMainIndex();
        centerCardByIndex(centerIdx, "smooth");

        setTimeout(function () {
          normalizeMainTrackLoop();
          updateMainTrack3DClasses();
          resumeMainTrackVideo();
          movedByDrag = false;
          tapCard = null;
          pointerScrolled = false;
          isVerticalGesture = false;
        }, 180);

        return;
      }

      if (tapCard && mainTrack.contains(tapCard) && pressDuration < 250) {
        var originalIndex = getOriginalSlideIndexFromCard(tapCard);
        tapCard = null;

        requestAnimationFrame(function () {
          openLightbox(originalIndex);
        });

        return;
      }

      tapCard = null;
      pointerScrolled = false;
      isVerticalGesture = false;
    }

    mainTrack.addEventListener("pointerdown", onPointerDown);
    mainTrack.addEventListener("pointermove", onPointerMove);
    mainTrack.addEventListener("pointerup", endMainDrag);
    mainTrack.addEventListener("pointercancel", endMainDrag);

    function centerInitialCardMobile() {
      if (window.innerWidth > 768) return;
      if (!mainTrack || !cards.length) return;

      var middleIndex = Math.floor((cards.length - 1) / 2);
      var targetCard = cards[middleIndex];
      if (!targetCard) return;

      mainTrack.scrollLeft = Math.max(0, getCardCenterTarget(targetCard));
    }

    var mainTrack3DTicking = false;
    function onMainTrackScroll3D() {
      if (mainTrack3DTicking) return;
      mainTrack3DTicking = true;

      requestAnimationFrame(function () {
        normalizeMainTrackLoop();
        updateMainTrack3DClasses();
        mainTrack3DTicking = false;
      });
    }

    mainTrack.addEventListener("scroll", onMainTrackScroll3D, { passive: true });
    window.addEventListener("resize", function () {
      updateMainTrack3DClasses();
    });

    var isMobileReel = window.innerWidth <= 595;

    var swiperBaseConfig = {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      mousewheel: { releaseOnEdges: true },
      touchReleaseOnEdges: true
    };

    if (!isMobileReel) {
      swiperBaseConfig.direction = "horizontal";
      swiperBaseConfig.effect = "coverflow";
      swiperBaseConfig.slidesPerView = "auto";
      swiperBaseConfig.centeredSlides = true;
      swiperBaseConfig.spaceBetween = 12;
      swiperBaseConfig.slideToClickedSlide = true;
      swiperBaseConfig.speed = 550;
      swiperBaseConfig.grabCursor = true;
      swiperBaseConfig.watchSlidesProgress = true;
      swiperBaseConfig.mousewheel = false;

      swiperBaseConfig.coverflowEffect = {
        rotate: 0,
        stretch: 0,
        depth: 320,
        scale: 0.9,
        modifier: 1.15,
        slideShadows: false
      };

      swiperBaseConfig.navigation = {
        nextEl: sectionEl.querySelector(".wtm-swiper-button-next"),
        prevEl: sectionEl.querySelector(".wtm-swiper-button-prev")
      };
    }

    var swiper = new Swiper(swiperEl, swiperBaseConfig);
    var currentIndex = swiper.activeIndex || 0;

    function setSwiperInteractivity(enabled) {
      swiper.allowTouchMove = enabled;

      if (swiper.mousewheel && swiper.mousewheel.enable && swiper.mousewheel.disable) {
        if (enabled) swiper.mousewheel.enable();
        else swiper.mousewheel.disable();
      }
    }

    function scrollMain(direction) {
      if (!cards.length) return;

      normalizeMainTrackLoop();

      var activeIdx = getCenteredMainIndex();
      var targetIdx = activeIdx + (direction > 0 ? 1 : -1);

      if (targetIdx < 0) targetIdx = 0;
      if (targetIdx > cards.length - 1) targetIdx = cards.length - 1;

      centerCardByIndex(targetIdx, "smooth");

      setTimeout(function () {
        normalizeMainTrackLoop();
        updateMainTrack3DClasses();
        resumeMainTrackVideo();
      }, 260);
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { scrollMain(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { scrollMain(1); });

    setTimeout(function () {
      centerInitialCardMobile();

      var idx = getCenteredMainIndex();
      centerCardByIndex(idx, "auto");

      updateMainTrack3DClasses();
      resumeMainTrackVideo();
    }, 80);

    function pauseAllVideos() {
      Array.prototype.forEach.call(swiperEl.querySelectorAll("video"), function (v) {
        v.pause();
      });
    }

    function hydrateLightboxVideo(video) {
      if (!video) return;
      var didSet = false;
      var vds = video.getAttribute("data-src");
      if (vds && !video.getAttribute("src")) {
        video.setAttribute("src", vds);
        video.removeAttribute("data-src");
        didSet = true;
      }
      var sources = video.querySelectorAll("source");
      Array.prototype.forEach.call(sources, function (s) {
        var ds = s.getAttribute("data-src");
        if (ds && !s.getAttribute("src")) {
          s.setAttribute("src", ds);
          s.removeAttribute("data-src");
          didSet = true;
        }
      });
      if (didSet) video.load();
    }

    function playSlide(index, reset) {
      currentIndex = index;

      var slides = swiperEl.querySelectorAll(".swiper-slide");
      Array.prototype.forEach.call(slides, function (slide, idx) {
        var v = slide.querySelector("video");
        var bar = slide.querySelector(".wtm-progress-inner");
        if (!v) return;

        if (idx === currentIndex && autoplayLightbox) {
          hydrateLightboxVideo(v);
          if (reset) {
            try { v.currentTime = 0; } catch (e) {}
            if (bar) bar.style.width = "0%";
          }
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    swiper.on("slideChange", function () {
      Array.prototype.forEach.call(
        swiperEl.querySelectorAll("[data-product-sheet]"),
        function (sheet) { sheet.classList.remove("is-open"); }
      );

      playSlide(swiper.activeIndex, true);
    });

    function openLightbox(index) {
      if (!lightbox || !swiper) return;

      pauseMainTrackVideos();
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");

      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.classList.add("wtm-lightbox-open");

      pauseAllVideos();

      var target = (typeof index === "number") ? index : 0;
      swiper.slideTo(target, 0);

      setTimeout(function () {
        swiper.update();
        swiper.updateSlidesClasses();
        playSlide(target, true);
      }, 30);
    }

    function closeLightbox() {
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");

      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.classList.remove("wtm-lightbox-open");

      pauseAllVideos();
      setSwiperInteractivity(true);

      requestAnimationFrame(function () {
        resumeMainTrackVideo();
      });
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener("click", closeLightbox);
    });

    if (backdrop) backdrop.addEventListener("click", closeLightbox);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && lightbox.classList.contains("is-open")) {
        closeLightbox();
      }
    });

    function bindSlideControls() {
      var slides = swiperEl.querySelectorAll(".swiper-slide");

      Array.prototype.forEach.call(slides, function (slide, index) {
        if (slide.getAttribute("data-wtm-bound") === "1") return;
        slide.setAttribute("data-wtm-bound", "1");

        var video = slide.querySelector("video");
        var progressInner = slide.querySelector(".wtm-progress-inner");
        var muteBtn = slide.querySelector(".wtm-mute-toggle");
        var shareBtn = slide.querySelector(".wtm-share-btn");

        var sheetPrice = slide.querySelector(".wtm-sheet-price");
        var sheetAddBtn = slide.querySelector(".wtm-sheet-add-to-cart");
        var hiddenIdInput = slide.querySelector(".wtm-sheet-variant-id");

        if (video && muteBtn) {
          video.muted = false;
          muteBtn.classList.add("is-unmuted");
        }

        var productCard = slide.querySelector("[data-product-card]");
        var productSheet = slide.querySelector("[data-product-sheet]");
        var sheetClose = slide.querySelector(".wtm-sheet-close");

        var productSheetEl = slide.querySelector("[data-product-sheet]");
        var variants = [];

        if (productSheetEl && productSheetEl.getAttribute("data-product-variants")) {
          try {
            variants = JSON.parse(productSheetEl.getAttribute("data-product-variants"));
          } catch (e) {
            variants = [];
          }
        }

        var variantInputs = slide.querySelectorAll(".wtm-sheet-form .wtm-size-pill input[type='radio']");

        function getCurrentOptions() {
          var result = [];
          var optionEls = slide.querySelectorAll(".wtm-sheet-option");

          Array.prototype.forEach.call(optionEls, function (optEl) {
            var idx = parseInt(optEl.getAttribute("data-option-index"), 10);
            if (isNaN(idx)) return;

            var checked = optEl.querySelector('input[type="radio"]:checked');
            if (checked) {
              result[idx] = checked.getAttribute("data-option-value") || checked.value;
            }
          });

          return result;
        }

        function findMatchingVariant(optionValues) {
          if (!variants || !variants.length) return null;

          var finder = variants.find
            ? function (fn) { return variants.find(fn); }
            : function (fn) {
                for (var i = 0; i < variants.length; i++) {
                  if (fn(variants[i])) return variants[i];
                }
                return null;
              };

          return finder(function (variant) {
            if (!variant.options || variant.options.length < optionValues.length) return false;
            for (var i = 0; i < optionValues.length; i++) {
              if (!optionValues[i]) return false;
              if (variant.options[i] !== optionValues[i]) return false;
            }
            return true;
          });
        }

        function applyVariantToUI(variant) {
          if (!variant) return;

          if (hiddenIdInput) hiddenIdInput.value = variant.id;
          if (sheetPrice && variant.price_formatted) sheetPrice.textContent = variant.price_formatted;

          if (sheetAddBtn) {
            if (variant.available) {
              sheetAddBtn.disabled = false;
              sheetAddBtn.classList.remove("is-sold-out");
              sheetAddBtn.textContent = "ADD TO CART";
            } else {
              sheetAddBtn.disabled = true;
              sheetAddBtn.classList.add("is-sold-out");
              sheetAddBtn.textContent = "SOLD OUT";
            }
          }
        }

        function updateFromSelections() {
          var opts = getCurrentOptions();
          var variant = findMatchingVariant(opts);
          applyVariantToUI(variant);
        }

        if (variantInputs.length) {
          updateFromSelections();
        }

        Array.prototype.forEach.call(variantInputs, function (input) {
          input.addEventListener("change", function () {
            updateFromSelections();
          });
        });

        if (video && progressInner) {
          video.addEventListener("timeupdate", function () {
            if (index !== currentIndex) return;
            if (!video.duration || isNaN(video.duration)) return;
            var pct = (video.currentTime / video.duration) * 100;
            progressInner.style.width = pct + "%";
          });

          video.addEventListener("ended", function () {
            if (index !== currentIndex) return;

            if (productSheet && productSheet.classList.contains("is-open")) {
              try { video.currentTime = 0; } catch (e) {}
              video.play().catch(function () {});
            } else {
              swiper.slideNext();
            }
          });
        }

        if (muteBtn && video) {
          muteBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            video.muted = !video.muted;
            muteBtn.classList.toggle("is-unmuted", !video.muted);
          });
        }

        if (shareBtn) {
          shareBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            var url = window.location.href;

            if (navigator.share) {
              navigator.share({ url: url }).catch(function () {});
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(url).catch(function () {});
            }
          });
        }

        if (video) {
          slide.addEventListener("click", function (e) {
            if (e.target.closest(".wtm-icon-btn") || e.target.closest("form")) return;

            if (index !== currentIndex) {
              swiper.slideTo(index);
              return;
            }

            if (video.paused) video.play().catch(function () {});
            else video.pause();
          });
        }

        if (productCard && productSheet) {
          productCard.addEventListener("click", function (e) {
            if (e.target.closest("form")) return;
            e.stopPropagation();

            productSheet.classList.add("is-open");
            setSwiperInteractivity(false);
          });
        }

        if (sheetClose && productSheet) {
          sheetClose.addEventListener("click", function (e) {
            e.stopPropagation();
            productSheet.classList.remove("is-open");
            setSwiperInteractivity(true);
          });
        }

        if (productSheet) {
          productSheet.addEventListener("click", function (e) {
            e.stopPropagation();
          });
        }
      });
    }

    bindSlideControls();
  }

  ensureSwiper(initWhenSwiperReady);
}